import { render, staticRenderFns } from "./NotizInhalt.vue?vue&type=template&id=2396d966&"
import script from "./NotizInhalt.vue?vue&type=script&lang=js&"
export * from "./NotizInhalt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports